<template>
  <div class="rich-text-max-height bg-white text-foreground rounded-md overflow-hidden mb-2">
    <trumbowyg
      v-model="valueText"
      :config="config"
      class="form-control"
      name="content"
      @input="onEditorInput"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import VueTrumbowyg from 'vue-trumbowyg';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'trumbowyg/dist/ui/trumbowyg.css';

Vue.use(VueTrumbowyg);

export default {
  name: 'InputRichText',
  props: {
    value: {}
  },
  data() {
    return {
      config: {
        btns: [
          ['viewHTML'],
          ['formatting'],
          ['strong', 'em', 'del'],
          ['superscript', 'subscript'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['removeformat']
        ],
        resetCss: true
        // removeformatPasted: true
      },
      valueText: this.value
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        return val;
      }
    }
  },
  methods: {
    onEditorInput(data) {
      const regex = /(\s*--tw-.+?;\s*)/g;
      this.inputVal = data.replace(regex, '');
    }
  }
};

</script>

<style>

    :root {
        --ck-border-radius: 9px;
    }

    .trumbowyg-box {
        min-height: 800px;
        max-width: 900px;
        min-width: 900px;
        padding: 10px;
    }

    .trumbowyg-editor {
      min-height: 800px;
    }

    .rich-text-max-height {
        min-height: 900px;
    }
</style>
